import { useNavigate } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import { ConfirmDrawer } from "@/app/ui/ConfirmDrawer";

export function CancelHotelBooking({
  open,
  closeDrawer,
}: {
  open: boolean;
  closeDrawer: () => void;
}) {
  const t = useTranslations();
  const navigate = useNavigate();

  return (
    <ConfirmDrawer
      open={open}
      onClose={closeDrawer}
      onConfirm={() => {
        navigate({ to: "/", search: { category: "hotels" } });
      }}
      title={t("hotels.cancelBooking")}
      description={t("hotels.cancelBookingDesc")}
      closeLabel={t("back")}
      confirmLabel={t("cancel")}
    />
  );
}
